import { render, staticRenderFns } from "./ResumenDemanda.vue?vue&type=template&id=7839349a&scoped=true"
import script from "./ResumenDemanda.vue?vue&type=script&lang=ts"
export * from "./ResumenDemanda.vue?vue&type=script&lang=ts"
import style0 from "./ResumenDemanda.vue?vue&type=style&index=0&id=7839349a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7839349a",
  null
  
)

export default component.exports